import React from "react";
import { StyleSheet, View } from "react-native";
import { layout } from "@/constants";
import { useAuth } from "@/hooks/auth";
import AppTitle from "./AppTitle";
import Logo from "./Logo";
import UserInstructions from "./UserInstructions";
import Text from "./base/Text";

/**
 * Welcome component that displays the Serenity logo, welcome text, and app title.
 * Used on both login and chat screens for consistent branding.
 * UserInstructions are only shown when user is logged in.
 */
export default function Welcome() {
  const { user } = useAuth();

  return (
    <View style={styles.container}>
      <Logo width={120} height={120} style={styles.logo} />
      <Text
        variant="regular"
        size="medium"
        color="secondary"
        style={styles.welcomeText}
      >
        Welcome to
      </Text>
      <AppTitle style={styles.appTitle} />
      {user && <UserInstructions />}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center"
  },
  logo: {
    marginBottom: layout.space.lg
  },
  welcomeText: {
    marginBottom: layout.space.sm,
    textAlign: "center"
  },
  appTitle: {
    marginBottom: layout.space.xl
  }
});
